import { pxToRem } from '@packages/themes/utils';
import { makeStyles } from '@/styles/v4/tss-react';

const CARD_RADIUS_PX = 16;
const PILL_RADIUS_PX = 30;
const PILL_OFFSET_PX = 15;

const useStyles = makeStyles<void, 'cta'>({ name: 'SubscriptionProductCard' })(
  ({ palette, breakpoints, spacing, typography }, _props, classes) => ({
    root: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(1),
      padding: spacing(1),
      borderRadius: pxToRem(CARD_RADIUS_PX),
      [breakpoints.up('md')]: {
        display: 'grid',
        gridRow: 'span 5',
        gridTemplateRows: 'subgrid',
        rowGap: spacing(1),
      },
    },
    featured: {
      [`&&:has(.${classes.cta}:hover)`]: {
        backgroundPosition: '0 0, 100% 50%',
      },
    },
    cta: {},
    outlined: {
      border: `${pxToRem(1)} solid ${palette.semantic.input.borderDefault}`,
    },
    pill: {
      position: 'absolute',
      top: pxToRem(-PILL_OFFSET_PX),
      left: '50%',
      transform: 'translateX(-50%)',
      padding: `${spacing(-1)} ${spacing(0)}`,
      borderRadius: pxToRem(PILL_RADIUS_PX),
      backgroundColor: palette.semantic.pill.success,
      color: palette.semantic.text.buttonPrimary,
      whiteSpace: 'nowrap',
    },
    imageContainer: {
      overflow: 'hidden',
      aspectRatio: '16 / 9',
      borderRadius: pxToRem(8),
      backgroundColor: palette.semantic.bg.layer2,
    },
    image: {
      display: 'block',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(1),
    },
    titleBlock: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(-1),
    },
    bundleProducts: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(-1),
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
    titleRow: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: spacing(-1),
    },
    details: {
      '& ul': {
        ...typography.bodyMd,
        margin: 0,
        paddingLeft: '1.5em',
      },
      '& ul:not(:last-child)': {
        marginBottom: spacing(1),
      },
    },
  })
);

export default useStyles;
